import { call, put, takeLatest, select } from "redux-saga/effects";
import api from "../api/api";
import PostApi from "../api/PostApi";
import {
  CREATE_COMMENT_ACTION_BASE,
  EDIT_COMMENT_ACTION_BASE,
  DELETE_COMMENT_ACTION_BASE,
  createCommentOptimistic,
  createCommentSuccess,
  createCommentFailed,
  enterEditMode,
  editCommentOptimistic,
  editCommentFailed,
  deleteCommentOptimistic,
  deleteCommentFailed,
} from "../actions/commentActions.js";
import { COMMENT_STATUS } from "../components/PostsList/components/Interactions/components/CommentsList/components/Comment/constants";
import { hideConfirmDialog, showAlert } from "../actions";
import shortid from "shortid";
import { selectUser } from "../util/selectors";
import windowDataLayer from "../util/windowDataLayer";

///////////////////////// HANDLERS \\\\\\\\\\\\\\\\\\\\\\\\\
function* handleEditCommentsRequests({ postId, commentId, content }) {
  let request = PostApi.getEditCommentsUrl({ postId, commentId, content });
  yield put(editCommentOptimistic({ postId, commentId, content }));
  yield put(enterEditMode({ postId, commentId, isEditMode: false }));
  try {
    yield call(api.put, request.url, request.config);
  } catch (error) {
    yield put(editCommentFailed(error));
  }
}

function* handleDeleteCommentsRequests({ postId, commentId }) {
  let request = PostApi.getDeleteCommentUrl({ postId, commentId });
  yield put(deleteCommentOptimistic({ postId, commentId }));
  yield put(hideConfirmDialog());
  try {
    yield call(api.delete, request.url, request.config);
  } catch (error) {
    yield put(deleteCommentFailed({ commentId, error }));
    yield put(hideConfirmDialog());
    yield put(showAlert("Sorry, couldn't delete post", "error"));
  }
}

function* handleCreateCommentRequests({ postId, content }) {
  const createCommentRequest = PostApi.getCreateCommentUrl(postId, content);
  const user = yield select(selectUser);
  const comment = {
    _id: shortid.generate(),
    content,
    owner: {
      id: user.uid,
      name: user.name,
      picture: user.picture,
    },
    status: COMMENT_STATUS.PENDING,
  };
  try {
    yield put(createCommentOptimistic(postId, comment));
    const { data: newComment } = yield call(api.post, createCommentRequest.url, createCommentRequest.config);
    yield put(createCommentSuccess(postId, comment._id, newComment));
    windowDataLayer.push({ event: "comment" });
  } catch (error) {
    yield put(createCommentFailed(postId, comment._id));
    yield put(showAlert("Unable to post comment", "error"));
  }
}

///////////////////////// WATCHERS \\\\\\\\\\\\\\\\\\\\\\\\\
export function* watchCommentRequests() {
  yield takeLatest(`${EDIT_COMMENT_ACTION_BASE}_REQUEST`, handleEditCommentsRequests);
  yield takeLatest(`${DELETE_COMMENT_ACTION_BASE}_REQUEST`, handleDeleteCommentsRequests);
  yield takeLatest(`${CREATE_COMMENT_ACTION_BASE}_REQUEST`, handleCreateCommentRequests);
}

export default watchCommentRequests;



// WEBPACK FOOTER //
// ./src/sagas/CommentSaga.js